"use strict";

var ThankYouCards = require('./ThankYouCards');

var SaveTheDates = require('./SaveTheDates');

var LetterpressSaveTheDates = require('./LetterpressSaveTheDates');

var WeddingPostponementAnnouncements = require('./WeddingPostponementAnnouncements');

module.exports = {
  ThankYouCards: ThankYouCards,
  SaveTheDates: SaveTheDates,
  LetterpressSaveTheDates: LetterpressSaveTheDates,
  ThankYouCardReprints: ThankYouCards,
  SaveTheDateReprints: SaveTheDates,
  LetterpressSaveTheDateReprints: LetterpressSaveTheDates,
  WeddingPostponementAnnouncements: WeddingPostponementAnnouncements
};